import { featureFlags } from '~/utils/featureFlags';

let gatewayInstance = null;
let fastApiInstance = null;

export const registerGatewayClient = (instance) => {
  gatewayInstance = instance;
};

export const registerFastApiClient = (instance) => {
  fastApiInstance = instance;
};

export const getClient = (flagKey) => (featureFlags[flagKey] ? fastApiInstance : gatewayInstance);

// Always the API Gateway instance, never the fast-api one — for callers (e.g. router
// guards, module-scope singletons) that need the gateway specifically and aren't making
// a per-call fast-api/gateway routing decision via a feature flag. Same instance the
// `arcaneApiGateway` plugin both `app.provide()`s and passes to `registerGatewayClient`,
// so it carries the same Auth0 bearer-token interceptor. May be null until the plugin
// installs during app bootstrap (see plugins/arcane-api-gateway.js).
export const getGatewayClient = () => gatewayInstance;
